@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../constants/spacing.module.less';
@import '../../../../../constants/screen-width-breakpoints.module.less';

.import-drawer {
  text-align: left;
  margin: auto;
}

.drawer-body {
  flex: 1;
  overflow-y: auto;
  background-color: var(--white);
}

.drawer-body-inner {
  max-width: 1064px; // 1000px + 2 * 32px (horizontal padding)
  margin: auto;
  padding: @space-0 @space-32;
}

.step-detective {
  margin: @space-32 auto @space-24 auto;
}

.step {
  padding-top: @space-32;
  padding-bottom: @space-64;
  margin: auto;
}

.drawer-footer {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border-top: 1px solid var(--default--background-color--13);
  padding: @space-24 @space-48;
  background: var(--default--background-color-22);
  text-align: right;
}
